import React, {FC, useRef, useState} from 'react';
import Ticket from "./Ticket.tsx";
import {ChevronLeft, ChevronRight} from "lucide-react";

interface Props {
    icon: React.ReactElement,
    disabled: boolean;
    onClick: () => void;
}

const TicketsSlideButton: FC<Props> = ({icon, onClick, disabled}) => {
    return (
        <button onClick={onClick} disabled={disabled} className="flex border items-center justify-center border-black rounded-full shadow-sm w-8 h-8">
            {icon}
        </button>
    );
}


const TicketSlide= ({tickets}: { tickets: any}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);
    const itemWidth = 100 // 100% de la largeur du conteneur
    const itemSpacing = 2 // 2 * 0.5rem (mx-2 équivaut à 0.5rem de chaque côté)
    const totalItemWidth = itemWidth + itemSpacing

    const goToPrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1)
        }
    }

    const goToNext = () => {
        if (currentIndex < tickets.length - 1) {
            setCurrentIndex(currentIndex + 1)
        }
    }

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartX.current = e.touches[0].clientX
    }

    const handleTouchMove = (e: React.TouchEvent) => {
        touchEndX.current = e.touches[0].clientX
    }

    const handleTouchEnd = () => {
        const swipeDistance = touchEndX.current - touchStartX.current
        if (Math.abs(swipeDistance) > 50) {
            if (swipeDistance > 0 && currentIndex > 0) {
                setCurrentIndex(currentIndex - 1)
            } else if (swipeDistance < 0 && currentIndex < tickets.length - 1) {
                setCurrentIndex(currentIndex + 1)
            }
        }
    }

    return (
        <div className=' flex w-full h-full items-center flex-row justify-between '>
            {tickets.length >1 && <TicketsSlideButton
                onClick={goToPrevious}
                disabled={currentIndex === 0}
                icon={<ChevronLeft color='#000'/>}
            />}
            < div className={`${ tickets.length > 1 ? 'w-[80%]' :'w-full' } flex flex-col items-center justify-center mx-1`}>
                <div className="w-full overflow-x-hidden relative ">
                    <div
                        className="relative flex w-full"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                    >
                        <div
                            className="flex w-full transition-transform duration-300 ease-in-out "
                            style={{
                                transform: `translateX(calc(-${currentIndex * totalItemWidth}% - ${currentIndex * 0.1}rem))`,
                                //marginLeft: "-0.1rem", // Compenser le mx-2 du premier élément
                                //marginRight: "-0.2rem", // Compenser le mx-2 du dernier élément
                            }}
                        >
                            {
                                tickets?.map((ticket: any, index: number) => (
                                        <Ticket key={index} currentIndex={index} totalTickets={tickets.length || 0}
                                                ticket={ticket}/>
                                ))
                            }
                        </div>
                    </div>
                </div>
                {/* Pagination dots
                {tickets.length >1 && <div className="flex flex-row overflow-scroll justify-center space-x-2 w-[80vw]">
                    {tickets?.map((_: any, index: number) => (
                        <button
                            key={index}
                            className={`w-2 h-2 my-2 rounded-full ${index === currentIndex ? "bg-green-600" : "bg-gray-300"}`}
                            onClick={() => setCurrentIndex(index)}
                        />
                    ))}
                </div>}*/}
            </div>
            {tickets.length >1 && <TicketsSlideButton
                onClick={goToNext}
                disabled={currentIndex === tickets?.length - 1}
                icon={<ChevronRight color='#000'/>}
            />}
        </div>
    );
};

export default TicketSlide;
